import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Detect browser language (en or de)
export function detectBrowserLanguage() {
  if (typeof navigator !== 'undefined') {
    const lang = navigator.language || (navigator.languages && navigator.languages[0]) || 'en';
    if (lang.toLowerCase().startsWith('de')) return 'de';
  }
  return 'en';
} 